import CryptoJS from 'crypto-js';

export function generateSecureToken(length = 32): string {
  const wordArray = CryptoJS.lib.WordArray.random(length);
  return wordArray.toString();
}
